export default __webpack_public_path__ + "75c420e93df43ba02c9f21156323fddf.svg";